import { useState } from "react"
import moment from "moment"
import { motion } from "framer-motion"
import Modal from "react-modal"

import { useWindowDimensions } from "utils/useWindowDimensions"

import { Button, Carousel } from "components/shared"

import { CloseIcon, FacebookLogo, GoogleLogo } from "assets/icons"
import { useAnimation } from "utils/useAnimation"

const SOURCES = {
  Facebook: {
    icon: <FacebookLogo />,
    url: "https://www.facebook.com/tirnanogclinic/reviews",
  },

  Google: {
    icon: <GoogleLogo />,
    url: "https://www.google.com/search?q=tir+na+nog+clinic&oq=tir+na+nog+clinic&aqs=chrome..69i57j46i175i199i512j0i512l2j0i22i30j69i60l3.2196j0j7&sourceid=chrome&ie=UTF-8#lrd=0x48670e9cc06d4a7b:0x4637664ffca3c155,1,,,",
  },
}

const IMAGE_DOMAINS = [
  "ik.imagekit.io",
  "lh3.googleusercontent.com",
  // "platform-lookaside.fbsbx.com",
  // "scontent.fluk1-1.fna.fbcdn.net",
  // "scontent.fewr1-6.fna.fbcdn.net",
  // "scontent.fewr1-5.fna.fbcdn.net",
]

const Reviews = ({ reviews }) => {
  const { width: vw } = useWindowDimensions()
  const { variants } = useAnimation()

  const [currentReview, setCurrentReview] = useState(false)
  const isSupportedImageModal = IMAGE_DOMAINS.findIndex((domain) => reviews[currentReview]?.user_image_url.includes(domain)) !== -1

  return (
    <div>
      <Carousel
        className="reviews-carousel cursor-grab"
        slidesToShow={vw >= 1280 ? 3.5 : vw >= 1024 ? 2.5 : 1.1}
        slidesToScroll={1}
        infinite={false}
        autoplay={false}
        speed={400}
      >
        {reviews.map((review, index) => {
          const isSupportedImage = IMAGE_DOMAINS.findIndex((domain) => review?.user_image_url.includes(domain)) !== -1
          return (
            <motion.div key={index} className="bg-blue-200/40 pt-12 p-6 md:p-10 relative flex flex-col justify-between" variants={variants}>
              <a
                href={SOURCES[review?.source_name].url}
                target="_blank"
                rel="noopener noreferrer"
                className="float-right w-6 h-6 absolute top-3 right-3"
                aria-label={review?.source_name}
              >
                {SOURCES[review?.source_name].icon}
              </a>
              <div className="space-y-2 flex flex-col">
                <p className="line-clamp-6" title={review.text}>
                  {review.text}
                </p>
                {review.text.length > 160 && (
                  <div className="flex">
                    <Button size="sm" className="text-[13px] font-medium" isLink onClick={() => setCurrentReview(index)}>
                      View more
                    </Button>
                  </div>
                )}
              </div>
              <a
                className="mt-8 flex items-center flex-col md:flex-row gap-2 md:gap-4 text-center max-w-lg"
                href={review?.url || SOURCES[review?.source_name]?.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={review?.source_name}
              >
                {review?.user_image_url &&
                  (isSupportedImage ? (
                    <img
                      src={review?.user_image_url}
                      alt={`profile-of-${review?.user_name}`}
                      className="flex-shrink-0 w-12 h-12 rounded-full overflow-hidden"
                      width={64}
                      height={64}
                    />
                  ) : (
                    <div className="w-12 h-12 rounded-full bg-blue text-white flex justify-center items-center">
                      <span className="text-xl">{review.user_name.substring(0, 1)}</span>
                    </div>
                  ))}
                <div className="flex flex-col items-center md:items-start text-left">
                  <div className="font-semibold mt-1 capitalize text-lg">{review.user_name}</div>
                  {review.published_at_datetime && <div className="font-medium">{moment(review.published_at_datetime).format("LL")}</div>}
                </div>
              </a>
            </motion.div>
          )
        })}
      </Carousel>
      <Modal
        isOpen={currentReview !== false}
        onRequestClose={() => setCurrentReview(false)}
        portalClassName="standard-modal"
        bodyOpenClassName="body-standard-modal-open"
      >
        <div className="flex justify-between">
          <h3 className="text-3xl">Review</h3>
          <button onClick={() => setCurrentReview(false)}>
            <CloseIcon width={32} height={32} />
          </button>
        </div>
        <div className="space-y-8 flex flex-col items-center">
          <p className="mt-4">{reviews[currentReview]?.text}</p>
          {reviews[currentReview]?.user_name && (
            <a
              className="flex items-center space-x-4 text-center max-w-lg"
              href="https://www.facebook.com/WellingtonEyeClinic/reviews"
              target="_blank"
              rel="noopener noreferrer"
            >
              {reviews[currentReview]?.user_image_url &&
                (isSupportedImageModal ? (
                  <img
                    src={reviews[currentReview]?.user_image_url}
                    alt={`profile-of-${reviews[currentReview]?.user_name}`}
                    className="flex-shrink-0 w-12 h-12 rounded-full overflow-hidden"
                    width={64}
                    height={64}
                  />
                ) : (
                  <div className="w-12 h-12 rounded-full bg-blue text-white flex justify-center items-center">
                    <span className="text-xl">{reviews[currentReview]?.user_name.substring(0, 1)}</span>
                  </div>
                ))}
              <div className="flex flex-col items-center md:items-start text-left">
                <h4 className="font-semibold capitalize text-lg">{reviews[currentReview].user_name}</h4>
                {reviews[currentReview].published_at_datetime && (
                  <h6 className="font-medium">{moment(reviews[currentReview].published_at_datetime).format("LL")}</h6>
                )}
              </div>
            </a>
          )}
        </div>
      </Modal>
    </div>
  )
}

export default Reviews
